// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class LinkedDispatchCustomerDispatch {
  readonly id: string;
  readonly name: string;
  readonly code: string;
  readonly address: string | null;
  readonly integrationId: string | null;
  readonly integrationType: Enums.IntegrationType;
  readonly linkedAt: string | null;
  readonly mergedAt: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.code = data.code === undefined ? '' : data.code;
    this.address = data.address === undefined ? null : data.address;
    this.integrationId = data.integrationId === undefined ? null : data.integrationId;
    this.integrationType =
      data.integrationType === undefined ? Enums.IntegrationType.Series : data.integrationType;
    this.linkedAt = data.linkedAt === undefined ? null : data.linkedAt;
    this.mergedAt = data.mergedAt === undefined ? null : data.mergedAt;
  }

  static zero(): LinkedDispatchCustomerDispatch {
    const zeroValues: ExcludeMethodsDeep<LinkedDispatchCustomerDispatch> = {
      id: NIL_UUID,
      name: '',
      code: '',
      address: null,
      integrationId: null,
      integrationType: Enums.IntegrationType.Series,
      linkedAt: null,
      mergedAt: null,
    };
    return new LinkedDispatchCustomerDispatch(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type LinkedDispatchCustomerDispatchWireFormat = {
  id: string;
  name: string;
  code: string;
  address: string | null;
  integrationId: string | null;
  integrationType: string;
  linkedAt: string | null;
  mergedAt: string | null;
};

type NewLinkedDispatchCustomerDispatchProps = PartialDeep<
  LinkedDispatchCustomerDispatch,
  { recurseIntoArrays: true }
>;
export const NewLinkedDispatchCustomerDispatch: (
  props: NewLinkedDispatchCustomerDispatchProps,
) => LinkedDispatchCustomerDispatch = (props) => new LinkedDispatchCustomerDispatch(props);

type NewLinkedDispatchCustomerDispatchFromWireFormatProps = PartialDeep<
  LinkedDispatchCustomerDispatchWireFormat,
  { recurseIntoArrays: true }
>;
export const NewLinkedDispatchCustomerDispatchFromWireFormat: (
  props: NewLinkedDispatchCustomerDispatchFromWireFormatProps,
) => LinkedDispatchCustomerDispatch = (props) => new LinkedDispatchCustomerDispatch(props);
